import { getQueryKeys } from "@/app/_module/services/helper";

const namespace = "agencies";

const agencyQueryKeys = {
  ...getQueryKeys(namespace),

  // Custom function keys for agencies-specific functionality
  all: [namespace] as const,
  lists: () => [namespace, "list"] as const,
  list: (filters?: { page?: number; limit?: number; search?: string; isActive?: boolean }) =>
    [namespace, "list", filters] as const,
  details: () => [namespace, "detail"] as const,
  detail: (id: string) => [namespace, "detail", id] as const,
  stats: () => [namespace, "stats"] as const,
  statsDetail: (agencyId: string, period?: string) => [namespace, "stats", agencyId, period] as const,
  addUser: (agencyId: string) => [namespace, "addUser", agencyId] as const,
  agencyUsers: (agencyId: string) => [namespace, "agencyUsers", agencyId] as const,
  subAgencies: (filters?: unknown) => [namespace, "subAgencies", filters] as const,
  performanceTrends: (agencyId: string, period?: string) => [namespace, "performanceTrends", agencyId, period] as const,
  subAgencyStats: (agencyId: string, period?: string) =>
    [namespace, "subAgencyStats", agencyId, period] as const,
  subAgentStats: (agencyId: string, period?: string) =>
    [namespace, "subAgentStats", agencyId, period] as const,
};

export default agencyQueryKeys; 